import { render, staticRenderFns } from "./parallax-container.vue?vue&type=template&id=613864ba&"
import script from "./parallax-container.vue?vue&type=script&lang=js&"
export * from "./parallax-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports